// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d2-table-columns-fixed-controller .d2p-button[data-v-197e48c6]{padding:2px;font-size:10px}", ""]);
// Exports
module.exports = exports;
